import React from "react";
import ReactHtmlParser from 'react-html-parser'

import * as S from "./styles";

function Item({ item, index }) {
	const { image, title, description, titleColor, textColor } = item;

	return (
    <S.Container>
      <S.Image>
        <img
          src={image.fields.file.url}
          alt={image.fields.title}
        />
      </S.Image>
      <S.Content>
        <S.Title color={'#230C87'}>{title}</S.Title>
        <S.Description color={'#230C87'}>
          {ReactHtmlParser(description)}
        </S.Description>
      </S.Content>
    </S.Container>
	);
}

export default Item;
